<template>
  <header
    class="relative flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat pt-0" :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
    
    <div class="w-full pb-10 flex flex-col items-center max-h-full ">
      <img class="hidden md:block py-20 max-h-full object-contain w-11/12 lg:w-8/12" src="@/assets/logo.png" />
      <img class="block md:hidden py-20 max-h-full object-contain w-12/12" src="@/assets/logomobile.png" />
      <img src="@/assets/organizan.png" class="w-11/12 md:w-9/12 lg:w-5/12" />
    </div>

    
  </header>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'HeaderSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>